// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3v8VJ","actionsCol":"EnrolledClinics_actionsCol__1zF6I"};